import { IconProps } from '../constants'
import SVGContainer from './svg-container'

const ExpandList = (props: IconProps) => (
  <SVGContainer {...props}>
    <path d='M11 10H3M11 6H3M11 14H3M11 18H3M15 17L18 20L21 17M15 7L18 4L21 7' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
  </SVGContainer>
)

export default ExpandList
